// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_adbf1d8","content":"_a77be12"};